/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Az oldal nem található",
  "ComingSoon": "Hamarosan",
  "YesanPersonalFinance": "Yesan, Személyes pénzügyek",
  "Yesan": "Yesan",
  "PersonalFinance": "Személyes pénzügyek",
  "YesanDownload": "Letöltés Yesan",
  "ThisWebsiteUsesCookies": "Sütiket használunk a webhelyünk teljesítményére és használatára vonatkozó információk gyűjtéséhez és elemzéséhez, valamint a közösségi médiafunkciók biztosításához. A folytatással Ön hozzájárul a",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Legyen pénzügyileg szabad",
  "inStepsAndActions": "8 lépésben és 3 cselekvésben.",
  "TrackPlanAnalyze": "Nyomon követés. Tervezz. Elemezd.",
  "FTrack": "1. Nyomon követés",
  "FPlan": "2. Tervezd meg a",
  "FAnalyze": "3. Elemzés",
  "Features": "Jellemzők",
  "FeaturesSubHeading": "Tiszta kezdő, már pénzügyekben jártas, ez az az alkalmazás, amire szüksége van ahhoz, hogy pénzügyileg szabaddá váljon.",
  "ManageAccounts": "Számlák kezelése",
  "CashLiquidFixedAssetsLiabilities": "Készpénz, likvid, befektetett eszközök és kötelezettségek.",
  "TrackTransactions": "Tranzakciók nyomon követése",
  "IncomesExpensesTransferInvestments": "Bevételek, kiadások, átutalások, befektetések.",
  "ImportExport": "Import / export",
  "YourDataAlwaysAccessible": "Az Ön adatai mindig elérhetőek.",
  "PlanYourFreedom": "Tervezze meg szabadságát",
  "StepsAwayFromFI": "8 lépésre a pénzügyi függetlenségtől.",
  "BudgetsAndGoals": "Költségvetés és célok",
  "CheckYourProgressAndAchieve": "Ellenőrizze a fejlődését és érje el pénzügyi céljait.",
  "DashboardAndAnalytics": "Műszerfal és analitika",
  "ReviewLearnOptimizeWith": "Tekintse át, tanuljon, optimalizáljon grafikonokkal, betekintésekkel, eszközökkel.",
  "Security": "Biztonság",
  "MilitaryGradeEncryption": "Katonai szintű titkosítás, biometriai támogatás, az Ön eszközein tárolt adatok.",
  "OfflineMode": "Offline üzemmód",
  "YourDataAlwaysAccessibleAndModif": "Az Ön adatai mindig elérhetőek és módosíthatóak.",
  "Track": "Nyomon követés",
  "Income": "Jövedelem",
  "Expense": "Költségek",
  "Transfer": "Átutalás",
  "transactionsAndManageAccounts": "tranzakciókat és kezelje a különböző számlákat:",
  "checkings": ".",
  "savings": "Megtakarítás",
  "realEstate": "Ingatlan",
  "stocks": "Tőzsde",
  "bonds": "Kötvények",
  "crypto": "Crypto",
  "notes": "Bankjegyek, készpénz pénztárca",
  "envelopes": "Borítékok",
  "privateEquity": "Magántőke",
  "metal": "Fém",
  "retirement": "Nyugdíjpénztár",
  "lifeInsurance": "Életbiztosítás",
  "intellectualProperty": "Szellemi tulajdon",
  "otherLiquidAsset": "Egyéb likvid eszközök",
  "otherFixedAsset": "Egyéb befektetett eszköz",
  "mortgage": "Jelzáloghitel",
  "loan": "Fogyasztói hitel",
  "creditCard": "Hitelkártya",
  "otherLiability": "Egyéb kötelezettség",
  "AccountsManagement": "Számlavezetés",
  "MultipleAccountsTypesAndGrouping": "Többféle számlatípus és csoportosítás",
  "LinkAccounts": "Számlák összekapcsolása az Ön intézményeivel (csak bizonyos országokban érhető el)",
  "SmartAccounts": "Intelligens számlák",
  "AddEditDeleteTransactions": "Tranzakciók hozzáadása / szerkesztése / törlése",
  "TickVerifiedTransactions": "Ellenőrzött tranzakciók bejelölése",
  "CategorizeTransactions": "Tranzakciók kategorizálása",
  "TagTransactions": "Tranzakciók megjelölése",
  "TrackKakeiboType": "Kakeibo típus nyomon követése",
  "TrackInvestments": "Befektetések nyomon követése (csak bizonyos országokban érhető el)",
  "ImportFromCSVFile": "Teljes vagy fokozatos tranzakciók importálása CSV fájlból",
  "ExportToCSVFile": "Tranzakciók exportálása CSV fájlba",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 lépés a pénzügyi függetlenség felé terv, részletes költségvetés készítése, pénzügyi céljaid gyorsabb elérése.",
  "levelsTowardsFI": "8 szint a pénzügyi függetlenség felé",
  "EstablishBudgetsPer": "Költségvetés megállapítása",
  "account": "számla",
  "accountType": "számlatípus",
  "KakeiboType": "Kakeibo típus",
  "category": "kategória",
  "tag": "címke",
  "label": "címke",
  "TrackBudgetsPerFrequency": "Költségvetések nyomon követése gyakoriságonként",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Célok létrehozása a kiadásokra, egyenlegre, pénzforgalomra, akciókra vonatkozóan",
  "TrackGoalsProgress": "A célok előrehaladásának nyomon követése",
  "ReviewLearnOptimizeWithReportsCharts": "Áttekintés, tanulás, optimalizálás jelentésekkel, diagramokkal, trendekkel, betekintésekkel, eszközökkel.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Pénzügyi kimutatások: Nettó vagyon",
  "FSPnL": "Pénzügyi kimutatások: Eredménykimutatás / Profit & Loss",
  "FSBalanceSheetAssetsLiabilities": "Pénzügyi kimutatások: Mérleg, eszközök, források",
  "FSCashFlow": "Pénzügyi kimutatások: Pénzforgalmi kimutatás, terhelés-hitel, pénzmozgások",
  "FSFlows": "Pénzügyi kimutatások: Flows",
  "FSRatios": "Pénzügyi kimutatások: Ratios",
  "TrendsMonthEnd": "Hó végi trendek: Bevételek és kiadások, pénzforgalom",
  "TrendsPerformance": "Teljesítménytendenciák: YoY, MoM, WoW",
  "IncomeTrendsPer": "Bevételi trendek per",
  "SpendingTrendsPer": "Kiadási trendek per",
  "RecurringItemsIE": "Ismétlődő tételek: Bevételek és kiadások",
  "DebtProgressTrends": "Adósság Haladás trendek",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD áttekintés, múlt hónap, trendek",
  "FIWCLE": "Pénzügyi függetlenség: Fali táblázat, kiadások életenergia szerint",
  "DebtPaydownSnowballAvalanche": "Adósságleépítés: Hógolyó, lavina",
  "FullyCustomizableAnalyticsRange": "Teljesen testreszabható analitikai időintervallum",
  "ContactUs": "Kapcsolatfelvétel",
  "Privacy": "Adatvédelem",
  "Terms": "Feltételek",
  "About": "A  oldalról",
  "IAgreeToThe": "Elfogadom a",
  "AndThe": "és a",
  "PrivacyPolicy": "Adatvédelmi szabályzat",
  "TermsOfUse": "Felhasználási feltételek",

  "DigitalSoftwareExperienceTagline": "Digitális szoftverélmény a modern világ számára",
  "DigitalExperience": "Digitális élmény",
  "SoftwareForTheModernWorld": "Szoftverek a modern világ számára",
  "MobileApplications": "Mobil alkalmazások",
  "forConnectedAndOfflineHumans": "a csatlakoztatott és offline emberek számára",
  "CloudSaaS": "Felhőalapú SaaS",
  "ResponsiveAndWebServices": "Responsive és webes szolgáltatások",
  "PersonalFinanceServices": "Személyes pénzügyi szolgáltatások",
  "YS_p1": "A Yesan egy dinamikus szoftvercég, amely a fogyasztókra szabott, élvonalbeli mobilalkalmazások fejlesztésére specializálódott. A Yesan a mai technológia iránt érdeklődő felhasználók változó igényeinek és preferenciáinak pontos ismeretében elkötelezett az intuitív, vonzó és funkciógazdag mobilélmények megalkotása mellett, amelyek gazdagítják a felhasználók életét.",
  "YS_p2": "A Yesan küldetésének középpontjában az innováció és a kreativitás iránti fáradhatatlan elkötelezettség áll, minden egyes termék aprólékosan kidolgozott, hogy zökkenőmentes funkcionalitást és kivételes felhasználói élményt nyújtson.",
  "PersonalFinanceApplication": "Személyes pénzügyi alkalmazás",
  "YPF_p1": "A Yesan, Personal Finance egy élvonalbeli személyes pénzügyi mobilalkalmazás, amelyet úgy terveztek, hogy a felhasználók számára átfogó pénzügyi menedzsmenteszközöket biztosít, amelyek kényelmesen elérhetőek az ujjhegyükön. A Yesan, Personal Finance elegáns és intuitív felületével holisztikus megközelítést kínál a pénzügyek kezeléséhez, és minden pénzügyi műveltségi szint felhasználóinak megfelel.",
  "YPF_p2": "A legfontosabb funkciók közé tartozik a költségvetés nyomon követése, a kiadások kategorizálása és a tranzakciók valós idejű nyomon követése, lehetővé téve a felhasználók számára, hogy könnyedén betekintést nyerjenek kiadási szokásaikba. Az alkalmazás testreszabható költségvetési lehetőségeket is kínál, lehetővé téve a felhasználók számára, hogy pénzügyi célokat tűzzenek ki, és nyomon kövessék az előrehaladásukat az idő múlásával.",
  "YPF_p3": "A Yesan, Personal Finance továbbá kiemelten kezeli a biztonságot, és a legkorszerűbb titkosítási protokollokat alkalmazza a felhasználók érzékeny pénzügyi információinak védelme érdekében. A banki szintű biztonsági intézkedéseknek köszönhetően a felhasználók magabiztosan összekapcsolhatják számláikat és szinkronizálhatják tranzakcióikat anélkül, hogy a magánéletük sérülne.",
  "YPF_p4": "A Yesan, Personal Finance túlmutat az alapvető költségvetés-tervezésen, mivel a pénzügyi döntések optimalizálása érdekében éleslátó elemzést és személyre szabott ajánlásokat kínál. Legyen szó a potenciális megtakarítási lehetőségek azonosításáról, a befektetési portfóliók nyomon követéséről vagy az adósságtörlesztési stratégiák kezeléséről, az alkalmazás személyre szabott betekintést nyújt, hogy segítse a felhasználókat pénzügyi céljaik elérésében.",
  "Discover": "Fedezze fel a",
  "Firstname": "Keresztnév",
  "Lastname": "Vezetéknév",
  "Company":"Cég",
  "Subject": "Tárgy",
  "Email": "E-mail",
  "Message": "Üzenet",
  "ThankYouForContactingUs": "Köszönjük, hogy kapcsolatba lépett velünk",
  "ValidFirstnameRequired": "Érvényes keresztnév szükséges.",
  "ValidLastnameRequired": "Érvényes vezetéknév szükséges.",
  "ValidEmailAddressRequired": "Kérjük, adjon meg egy érvényes e-mail címet.",
  "ValidSubjectRequired": "Kérjük, válasszon egy érvényes tárgyat.",
  "ValidMessageRequired": "Kérjük, adjon meg egy érvényes üzenetet.",
  "UnableToSendTheFormPleaseRetryLater": "Nem sikerült elküldeni az űrlapot, kérjük, próbálja meg később újra.",
  "Information": "Információ",
  "Sales":"Értékesítés",
  "Support": "Támogatás",
  "Press": "Sajtó",
  "Partnership": "Partnerség",
  "Other": "Egyéb",
  "Blog":"Blog",

  "Accept":"Elfogadom",
  "Decline":"Visszautasítás",

  "WorklogCalendar":"Munkanapló naptár a Jira számára",

  "DirectlyAccessibleInProjectApps":"Közvetlenül elérhető a projektalkalmazásokban",
  "VisualizeWhereYouSpentYourTime":"Vizualizálja, hogy hol töltötte az idejét",
  "AllYourWorklogsInACalendar":"Az összes munkanaplója egy naptárban",
  "MonthSummary":"Havi összefoglaló",
  "CheckIfYouForgotToLogTime":"Ellenőrizze, hogy elfelejtett-e időt naplózni.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Közvetlen hozzáférés a problémákhoz és az idő frissítése",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Kattintson a munkanaplóelemre a problémák közvetlen eléréséhez és a nyomon követett idő szerkesztéséhez",
  "AlsoAvailableInDarkMode":"Sötét üzemmódban is elérhető",
  "DirectlyLogWorkOnTheCalendarVisually":"Közvetlenül naplózza a munkát a naptárban vizuálisan",
  "ClickOnTheCalendarToCreateNewWorklog":"Új munkanapló létrehozásához kattintson a naptárra",

  "AppsForAtlassian":"Alkalmazások az Atlassian számára",
  "YCL_p1":"Vizualizáld az összes munkanaplót egy naptárban, havi, heti, munkaheti, napi nézetekkel.",
  "YCL_p2":"Naplózza a munkát közvetlenül a naptárból vizuálisan kiválasztva az idősávot.",
  "YCL_p3":"Azonosítsa, ha elfelejtette nyomon követni az időt a munkaidő-nyilvántartásokhoz.",
  "YCL_p4":"Elérhető az Ön nyelvén: Angol (Egyesült Királyság), angol (USA), kínai (egyszerűsített), kínai (hagyományos), cseh, dán, holland, észt, finn, francia, német, magyar, izlandi, olasz, japán, koreai, japán, norvég, lengyel, portugál (Brazília), portugál (Portugália), orosz, spanyol, svéd, török.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Pénzügyi portfólió a Jira számára",
  "BringRealFinancialPortfolio":"Valódi pénzügyi portfóliókezelés a Jira-ban. Kövesse nyomon a költségvetéseket, a beruházási és működési költségeket, valamint a projektköltségeket egy helyen.",
  "YFPAboutQ":"Mennyibe kerülnek valójában a Jira-projekteink?",
  "YFPAbout":"Pénzügyi portfólió a Jira számára\nA pénzügyi vezetők és a PMO-k nehezen tudnak választ adni egy egyszerű kérdésre:\nMennyibe kerülnek valójában a Jira-projekteink?\nA Jira nyomon követi a munkát.\nA pénzügy nyomon követi a költségvetéseket.\nEz az alkalmazás végre összeköti a kettőt.\n\nA Financial Portfolio a Jira-t egy könnyű PPM + pénzügyi tervezési platformmá alakítja — drága vállalati eszközök nélkül.",
  "YFPPorfolioQ":"Portfólió-költségvetések és nyomon követés",
  "YFPPorfolioP":"Hozzon létre portfóliókat több Jira-projekt között, és határozza meg: a költségvetés összegét, a pénznemet, az időtartományt, a benne szereplő projekteket és csapatokat. Kövesse nyomon automatikusan a tényleges költségeket, ahogy a munka a Jira-ban halad.",
  "YFPPorfolioListQ":"Portfóliók",
  "YFPPorfolioListP":"Hozzon létre olyan pénzügyi portfóliókat, amelyek több Jira-projektet egyesítenek, és azonnal láthatja: a költségvetést a tényleges költségekkel összehasonlítva, a projekt valós idejű kiadási ütemét, a CapEx és OpEx bontását, a feladat- és projektköltségeket, valamint exportálható pénzügyi jelentéseket. Mindezt közvetlenül a Jira munkajelentései alapján.",
  "CostQ":"Automatikus költségszámítás",
  "CostP":"Alakítsa az időkövetést valódi pénzügyi adatokká. Az alkalmazás: beolvassa a Jira munkajelentéseket, alkalmazza az óradíjakat, naponta kiszámítja a valós projektköltségeket. Nincs szükség táblázatokra. Nincs kézi munka.",
  "RatesQ":"Óradíjak",
  "RatesP":"Óradíj beállítása projektenként, csapatonként, globálisan",
  "ReportQ":"CSV pénzügyi jelentések",
  "ReportP":"Portfólió pénzügyi adatainak másodpercek alatt történő exportálása. Tökéletes: pénzügyi csapatok, CFO-jelentések, költségvetés-tervezés, könyvvizsgálati támogatás",
  "SettingsQ":"CapEx vs OpEx osztályozás",
  "SettingsP":"Támogatja a számviteli és könyvvizsgálati követelményeket. Osztályozza a munkát: tőkésíthető fejlesztés (CapEx), operatív munka (OpEx). Készítsen exportálható jelentéseket a pénzügyi csapatok számára."
};

export const documents = {
};
